import styled from "styled-components";
import Dialog from "../../../../../../components/dialog/dialog";

export const AddProjectsModalStyled = styled(Dialog)`
  width: 70%;
  height: 541px;
  .body {
    padding: 20px;
  }

  .heading{
    gap: 7px;
    display: grid;
  }

  .checkbox {
    display: flex;
    justify-content: center;
    align-items: center;
    .MuiFormControlLabel-root {
      margin: 0px;
    }
  }

  .MuiPaper-root {
    max-height: 390px;
    padding: 0
  }

  .table {
    margin-top: 10px;
    tr{
    background-color: white !important;}
  }
`;
